import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";
import { ListRequestQuery } from "../../../../utils/serviceHelper";
import { StatementQuerySort } from "../../../../modules/Statements/routes/RouteStatements";

export enum StatementStatus {
  Draft = "Draft",
  Available = "Available",
  Archived = "Archived"
}

export type IStatementsFilters = {
  accountType?: { in: bankingApiSpec.InternalAccountType[] };
  status?: StatementStatus;
  startDate?: { ">="?: Date; "<="?: Date };
  endDate?: { ">="?: Date; "<="?: Date };
};

export type IStatementsRequestQuery = ListRequestQuery<
  IStatementsFilters,
  StatementQuerySort
>;
